import ko from '@tko/build.knockout';
import Vue from 'vue';
import Vuetify from '../../../plugins/vuetify';
import templateMarkup from 'raw-loader!./admin-view.html';

import "core-js/stable";
import "regenerator-runtime/runtime";
import App from '../components/App/App.vue';
import LoginService from '../../../services/login.service';
import router from '../router';
import { store } from '../store/index';
import VueClipboard from 'vue-clipboard2';
import DataProvider from "../../../app/data-framework/data-provider";
VueClipboard.config.autoSetContainer = true; // add this line

Vue.use(VueClipboard);
Vue.use(Vuetify);
global.Window = window;

class AdminView {
    constructor(params) {
        let self = this;
        self.dataProvider = DataProvider.getInstance();
        self.route = params.route;

        LoginService.getActiveSession().then((userObject) => {
            store.commit('user/setUserInfo', userObject);
            store.commit('user/setDataProvider', this.dataProvider);
            store.dispatch('user/transferAuth');
            store.dispatch('menus/setMenus');

            self.adminApp = new Vue({
              el: '#adminApp',
              router,
              store,
              render: h => h(App),
              vuetify: Vuetify
            });
            // hack for login because navigation is not triggered
            if (router.currentRoute.path !== window.location.hash.substring(1)) {
              router.push({path: window.location.hash.substring(1)});
            }
        }).catch((error) => { LoginService.navigateToLogin(error)});

        self.routeSubscription = self.route.subscribe(function() {
            const newPath = window.location.hash.substring(1);
            if (router.currentRoute.path !== newPath) {
                router.push({path: newPath});
            }
        });
    }

    dispose() {
        let self = this;
        if (self.routeSubscription) {
            self.routeSubscription.dispose();
        }
        if (self.adminApp) {
            self.adminApp.$destroy();
            self.adminApp.$el.parentNode.removeChild(self.adminApp.$el);
        }
    }
}
ko.components.register('admin-view', { template: templateMarkup, viewModel: AdminView });
export default { template: templateMarkup, viewModel: AdminView }
